import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	knownErrorNonAdminTitle: {
		id: 'business-categories.controllers.category-cell-state-controller.known-error-non-admin-title',
		defaultMessage: 'Error editing this field',
		description:
			'Title text shown in error flag when a non-admin user cannot assign a category to an issue, either due to lacking permissions or the field is not supported by the issue type',
	},
	knownErrorNonAdminDescription: {
		id: 'business-categories.controllers.category-cell-state-controller.known-error-non-admin-description',
		defaultMessage:
			'You’ll either need edit permissions, or the project admin will need to add the category field to this issue type. To learn more, speak to your project admin.',
		description:
			'Description text shown in error flag when a non-admin user cannot assign a category to an issue, either due to lacking permissions or the field is not supported by the issue type',
	},
	knownErrorAdminTitle: {
		id: 'business-categories.controllers.category-cell-state-controller.known-error-admin-title',
		defaultMessage:
			'To edit this field you’ll need to go to project settings and add the category field to this issue type.',
		description:
			'Title text shown in error flag when an admin user cannot assign a category to an issue, because the field is not supported by the issue type',
	},
	knownErrorAdminCta: {
		id: 'business-categories.controllers.category-cell-state-controller.known-error-admin-cta',
		defaultMessage: 'Go to project settings',
		description:
			'Message to be shown as error flag CTA, telling the user to go to project settings',
	},
	networkErrorTitle: {
		id: 'business-categories.controllers.category-cell-state-controller.network-error-title',
		defaultMessage:
			'An unexpected error occurred. Check your network connection, then refresh your page to try again.',
		description:
			'Title text shown in error flag when user cannot assign a category to an issue, due to network error',
	},
	genericErrorTitle: {
		id: 'business-categories.controllers.category-cell-state-controller.generic-error-title',
		defaultMessage:
			'An unexpected error occurred. Wait a few moments, then refresh your page to try again.',
		description:
			'Title text shown in generic error flag when user cannot assign a category to an issue',
	},
	createdCategoryNameCantBeEmpty: {
		id: 'business-categories.controllers.category-cell-state-controller.created-category-name-cant-be-empty',
		defaultMessage: 'Categories can’t be left blank. To create a category, give it a name.',
		description: 'Message shown when user tries to create category with empty name',
	},
	renamedCategoryCantBeEmpty: {
		id: 'business-categories.controllers.category-cell-state-controller.renamed-category-cant-be-empty',
		defaultMessage: 'Categories can’t be left blank. To rename a category, give it a name.',
		description: 'Message shown when user tries to rename category into empty',
	},
	categoryNameAlreadyExists: {
		id: 'business-categories.controllers.category-cell-state-controller.category-name-already-exists',
		defaultMessage: 'The name you’ve selected for this category already exists. Try a new name.',
		description:
			'Message shown when user tries to rename/create category to a name that already used by another category',
	},
	knownErrorNonAdminDescriptionIssueTermRefresh: {
		id: 'business-categories.controllers.category-cell-state-controller.known-error-non-admin-description-issue-term-refresh',
		defaultMessage:
			'You’ll either need edit permissions, or the project admin will need to add the category field to this work type. To learn more, speak to your project admin.',
		description:
			'Description text shown in error flag when a non-admin user cannot assign a category to an issue, either due to lacking permissions or the field is not supported by the issue type',
	},
	knownErrorAdminTitleIssueTermRefresh: {
		id: 'business-categories.controllers.category-cell-state-controller.known-error-admin-title-issue-term-refresh',
		defaultMessage:
			'To edit this field you’ll need to go to project settings and add the category field to this work type.',
		description:
			'Title text shown in error flag when an admin user cannot assign a category to an issue, because the field is not supported by the issue type',
	},
});
